import { styled } from 'styled-components'

export const StyledContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 4px;
`

export const StyledCampaignCode = styled.div`
  font-size: 12px;
  font-weight: bold;
`
